import {Record} from 'immutable';
import moment from 'moment';

const record = Record({
  id: null,
  link: null,
  workingSetId: null,
  jobStatusTopic: null,
  status: null,
  name: null,
  publishedUrl: null,
  originalUrl: null,
  originalSize: null,
  optimizedUrl: null,
  optimizedSize: null,
  uploadedUrl: null,
  createdAt: null,
  updatedAt: null,
});

class WorkingSetImage extends record {
  get createdAt() {
    return moment(super.createdAt);
  }

  get updatedAt() {
    return moment(super.updatedAt);
  }

  get originalUrl() {
    return `${super.originalUrl}?u=${this.updatedAt.unix()}`
  }

  get optimizedUrl() {
    return `${super.optimizedUrl}?u=${this.updatedAt.unix()}`
  }
}

export default WorkingSetImage;



// WEBPACK FOOTER //
// ./app/javascript/records/WorkingSetImage.js